import { StoreState } from "../common/redux.store";

export function getCurrentProjectName(state: StoreState) {
    return state.app.currentProject?.name;
}

export function getCreateProjectErrorMessage(state: StoreState) {
    return state.app.createProjectErrorMessage;
}